export const layoutConstants = {
    LAYOUT_MIN_MOBILE_WIDTH: 360,
    LAYOUT_MIN_TABLET_WIDTH: 600,
    CUSTOM_LAYOUT_MIN_TABLET:768,
    LAYOUT_MAX_TABLET_WIDTH: 599,
    CUSTOM_LAYOUT_MAX_TABLET:767
  };